import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Select from "react-select";
import { CATEGORIES } from "../categories";

export default function BasicFields({
    challenge,
    setChallenge,
    onTypeChange,
    onChangeProgress,
    onIntervalChange,
    descriptionLength,
    setDescriptionLength,
    challengeNameRef,
    descriptionRef,
    markdownRef,
}) {
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="challengeNameControl">
                    <Form.Label>Challenge Name</Form.Label>
                    <Form.Control
                        name="challengeName"
                        required
                        type="text"
                        placeholder="Challenge Name"
                        ref={challengeNameRef}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide a challenge name
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Row className="mb-2">
                <Form.Group as={Col} md="7">
                    <Form.Label className="fw-semibold">Challenge Type</Form.Label>
                </Form.Group>
                <Form.Group as={Col} md="5">
                    <Form.Label className="fw-semibold">Progress Type</Form.Label>
                </Form.Group>
            </Row>
            <Row className="mb-3">
                <Form.Group as={Col} md="7">
                    <ToggleButtonGroup
                        type="radio"
                        name="challengeType"
                        value={challenge.ChallengeType}
                        onChange={onTypeChange}
                    >
                        <ToggleButton id="ct-basic" value="BASIC">Basic</ToggleButton>
                        <ToggleButton id="ct-basicinterval" value="BASICINTERVAL">Basic Interval</ToggleButton>
                        <ToggleButton id="ct-categories" value="CATEGORIES">Categories</ToggleButton>
                        <ToggleButton id="ct-enterasyougo" value="ENTERASYOUGO">Enter AYG</ToggleButton>
                        <ToggleButton id="ct-calendar" value="CALENDAR">Calendar</ToggleButton>
                    </ToggleButtonGroup>
                </Form.Group>
                <Form.Group as={Col} md="5">
                    <ToggleButtonGroup
                        type="radio"
                        name="progressType"
                        value={challenge.ProgressType}
                        onChange={onChangeProgress}
                    >
                        <ToggleButton id="pt-fraction" value="fraction">Fraction</ToggleButton>
                        <ToggleButton id="pt-percentage" value="percentage">Percentage</ToggleButton>
                    </ToggleButtonGroup>
                </Form.Group>
            </Row>

            {challenge.ChallengeType === "BASICINTERVAL" && (
                <Row className="mb-3">
                    <Form.Group as={Col} md="5">
                        <Form.Label className="fw-semibold">Challenge Interval</Form.Label>
                        <div>
                            <ToggleButtonGroup
                                type="radio"
                                name="challengeInterval"
                                value={challenge.Interval}
                                onChange={onIntervalChange}
                            >
                                <ToggleButton id="ci-daily" value="DAILY">Daily</ToggleButton>
                                <ToggleButton id="ci-weekly" value="WEEKLY">Weekly</ToggleButton>
                                <ToggleButton id="ci-monthly" value="MONTHLY">Monthly</ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                    </Form.Group>
                </Row>
            )}

            <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="categoriesControl">
                    <Form.Label className="fw-semibold">Categories</Form.Label>
                    <Select
                        isMulti
                        inputId="categories-select"
                        placeholder="Select categories"
                        options={CATEGORIES.map(c => ({ label: c, value: c }))}
                        onChange={value =>
                            setChallenge({
                                ...challenge,
                                Categories: (value || []).map(x => x.value),
                            })
                        }
                        value={challenge.Categories.map(c => ({ label: c, value: c }))}
                    />
                </Form.Group>
            </Row>

            <Row className="mb-3">
                <Form.Group as={Col} md="10" controlId="descriptionControl">
                    <Form.Label>Description ({descriptionLength}/96)</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Description"
                        ref={descriptionRef}
                        name="Description"
                        maxLength="96"
                        onChange={() =>
                            setDescriptionLength(
                                descriptionRef?.current?.value?.length ?? 0
                            )
                        }
                    />
                </Form.Group>
            </Row>

            <Row className="mb-3">
                <Form.Group as={Col} md="10" controlId="markdownControl">
                    <Form.Label>Markdown</Form.Label>
                    <Form.Control
                        rows={4}
                        as="textarea"
                        placeholder="Markdown"
                        ref={markdownRef}
                        name="Markdown"
                    />
                </Form.Group>
            </Row>
        </>
    );
}
